import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { Code, CodeTypeLabel } from '../../data/smart-devices.interface';

@Component({
  standalone: false,
  selector: 'sbnb-smart-device-guests-table',
  templateUrl: 'smart-device-guests-table.component.html',
  styleUrls: ['smart-device-guests-table.component.scss'],
})
export class SmartDeviceGuestsTableComponent {
  CodeTypeLabel = CodeTypeLabel;

  DATE_FORMAT = "MMM d - h:mm aaaaa'm'";
  displayedColumns: string[] = [
    'name',
    'start',
    'end',
    'code',
    'used',
    'thermostat-setting',
    'current-preset',
    'properties',
  ];

  isMobile$ = this.deviceDetectionService.isMobileViewport();

  @Input() codes: Code[] = [];
  @Input() singleProperty = true;
  @Input() showThermostatColumns = true;
  @Output() nameClicked: EventEmitter<string> = new EventEmitter();

  constructor(private deviceDetectionService: DeviceDetectionService) {}

  ngOnInit() {
    if (!this.showThermostatColumns) {
      this.displayedColumns = this.displayedColumns.filter(
        (col) => col !== 'thermostat-setting' && col !== 'current-preset'
      );
    }
  }

  trackCode(index: number, code: Code): string {
    return code.name;
  }
}
